import React from "react";
import { useNavigate } from "react-router-dom";
import logo from "../Images/logo.png";
import { FcHome } from "react-icons/fc";
import { AiOutlineLogout } from "react-icons/ai";
import { FcCurrencyExchange } from "react-icons/fc";
import { Tooltip } from "react-tooltip";

function Header() {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    navigate("/");
  };

  return (
    <header>
      <h2 className="logo">
        <img src={logo} alt="logo" width={"40px"} /> Maa Bagheshwari Pathology
      </h2>

      <div className="links">
        <ul>
          <li>
            <FcHome />
            <span> Home</span>
          </li>
          <li>
            <FcCurrencyExchange />
            <span>Expenses</span>
          </li>
          <li>
            {user?.role === "admin" && (
              <a href="/register" className="link">
                Registration
              </a>
            )}

            <Tooltip id="saveTip" place="top" />

            <button
              onClick={handleLogout}
              className="logout"
              data-tooltip-id="saveTip"
              data-tooltip-content={`Hi, ${user?.name}`}
            >
              <AiOutlineLogout />
              <span> Logout</span>
            </button>
          </li>
        </ul>
      </div>
    </header>
  );
}

export default Header;
